var render = function render(){var _vm=this,_c=_vm._self._c;return _c('template-base',[_c('div',{staticClass:"d-flex justify-content-between"},[_c('h1',{staticClass:"align-self-center"},[_vm._v("MMI Utilities")])]),_c('p',[_vm._v("Use o menu lateral para navegar pelo sistema.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }